import { Show } from '@/components/show'

interface EntrySerieProps {
  disciplineSerie: string
  selectedSerie?: string
}

export const EntrySerie = ({
  disciplineSerie,
  selectedSerie
}: EntrySerieProps) => {
  return (
    <Show when={disciplineSerie === selectedSerie}>
      <p className="uppercase text-[var(--brand-blue-1)]">ingresso</p>
    </Show>
  )
}
